import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { adminService } from '@/api/services/adminService'

// Define initial state
const initialState = {
  reports: [] as { id: string; name: string }[], // Ensure `roles` is always an array
  loading: false,
  error: null as string | null,
};

// Async thunk for fetching roles
export const fetchReports = createAsyncThunk('reports/fetchReports', async () => {
  try {
    const response = await adminService.reportAll();
    console.log("API Response:", response.data); // Debugging output
    return response.data.data; // Extract only the `data` array
  } catch (error) {
    console.error("Error fetching reports:", error);
    throw new Error('Failed to fetch reports');
  }
});

const reportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    resetReportState: () => initialState, // Now `initialState` is defined
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Redux Payload (Fixed):", action.payload); // Should be an array
        state.reports = action.payload || []; // Ensure it's an array
      })                     
      .addCase(fetchReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to fetch reports';
      });
  },
});

export default reportSlice.reducer;
export const { resetReportState } = reportSlice.actions; // Export actions
